import { render } from "./courseRankList.vue?vue&type=template&id=68a47c32&scoped=true"
import script from "./courseRankList.vue?vue&type=script&lang=js"
export * from "./courseRankList.vue?vue&type=script&lang=js"

import "./courseRankList.vue?vue&type=style&index=0&id=68a47c32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a47c32"]])

export default __exports__